"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMultiToMyTicketModel = (data) => {
    return data.map(d => {
        return {
            movieId: d.MovieId,
            movieTitle: d.MovieTitle,
            notes: d.Notes,
            qrCode: d.QRCode,
            qrUrl: d.QRUrl,
            startTime: d.StartTime,
            expirationDate: d.ExpirationDate,
            image: d.Poster,
            sal: d.Screen,
            seatsInfo: convertToSeatsInfoModel(d.SeatsInfo)
        };
    });
};
const convertToSeatsInfoModel = (data) => {
    return {
        info: data.Info,
        seats: convertToSeatsModel(data.Seats)
    };
};
const convertToSeatsModel = (data) => {
    return data.map(d => {
        return {
            row: d.Row,
            seats: d.Seats
        };
    });
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/converters/ticketConverter.ts